module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.4fff33ac.woff";